import { APPLICATION } from "#/constants";
import axios from "axios";
import { formatURL, headerDecorator, requestDecorator } from "./utils";
import { THeaders } from "#/types";

const httpClient = axios.create({
  baseURL: APPLICATION.BFF_URL,
});

export class ApiService {
  private url: string;
  private accessToken?: string;

  constructor(url: string, accessToken?: string) {
    this.url = url;
    this.accessToken = accessToken;
  }

  protected get(
    url: string,
    queryParams?: string,
    headers?: THeaders
  ) {
    return requestDecorator(
      httpClient.get(formatURL(`${this.url}${url}`, queryParams), {
        headers: headerDecorator(headers, this.accessToken),
      })
    );
  }

  protected download(
    url: string,
    queryParams?: string,
    headers?: THeaders
  ) {
    return requestDecorator(
      httpClient.get(formatURL(`${this.url}${url}`, queryParams), {
        headers: headerDecorator(headers, this.accessToken),
        responseType: "blob",
      })
    );
  }

  protected post(
    url: string,
    data: any,
    queryParams?: any,
    headers?: THeaders
  ) {
    return requestDecorator(
      httpClient.post(formatURL(`${this.url}${url}`, queryParams), data, {
        headers: headerDecorator(headers, this.accessToken),
      })
    );
  }

  protected delete(
    url: string,
    queryParams?: any,
    headers?: THeaders
  ) {
    return requestDecorator(
      httpClient.delete(formatURL(`${this.url}${url}`, queryParams), {
        headers: headerDecorator(headers, this.accessToken),
      })
    );
  }
}
